// export default {
//   FONT_SIZE_SMALL: "14px",
//   FONT_SIZE_MEDIUM: "16px",
//   FONT_SIZE_LARGE: "18px",
//   FONT_SIZE_LARGE_PLUS: "20px",
//   FONT_SIZE_EXTRA_LARGE: "22px",
//   FONT_SIZE_BIG_TITLE: "24px",
//   PRIMARY_COLOR: "rgb(30, 147, 242)",
//   SECONDARY_COLOR: "rgb(238, 167, 2)",
//   FONT_WEIGHT_LIGHT: 200,
//   FONT_WEIGHT_MEDIUM: 600,
//   FONT_WEIGHT_HEAVY: 800,
//   HITSLOP: { top: 20, bottom: 20, left: 20, right: 20 },
// };

import { widthPercentageToDP as wp } from "react-native-responsive-screen";

export default {
  FONT_SIZE_SMALL: wp(3),
  FONT_SIZE_MEDIUM: wp(3.5),
  FONT_SIZE_LARGE: wp(4),
  FONT_SIZE_LARGE_PLUS: wp(4.5),
  FONT_SIZE_EXTRA_LARGE: wp(5),
  FONT_SIZE_BIG_TITLE: wp(5.5),
  PRIMARY_COLOR: "rgb(30, 147, 242)",
  SECONDARY_COLOR: "rgb(238, 167, 2)",
  FONT_WEIGHT_LIGHT: 200,
  FONT_WEIGHT_MEDIUM: 600,
  FONT_WEIGHT_HEAVY: 800,
  HITSLOP: { top: 20, bottom: 20, left: 20, right: 20 },
};
